import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import CPOShipmentList from "../../molecules/CPO/CPOShipmentList";
import CPOShipmentForm from "../../molecules/CPO/CPOShipmentForm";
import LGModal from "../../molecules/LGModal";
import { useSnack } from "../../services/SnakbarProvider";
import { handleError } from "../../services/errorHandler";
import {
  createCPOShipment,
  deleteCPOShipment,
  getCPOShipments,
} from "../../api/clientPurchaseOrders";

const CPOShipments = ({ props }) => {
  const details = props?.details || [];
  const companyId = props?.companyId;
  const [selectedDetailId, setSelectedDetailId] = useState(
    details[0]?.id ?? ""
  );
  const [shipments, setShipments] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { openSnack } = useSnack();

  const selectedDetail = details.find((d) => d.id === selectedDetailId);
  const shippedTotal = shipments.reduce(
    (sum, s) => sum + (s.shippedQuantity || 0),
    0
  );

  const handleSubmit = async (values) => {
    try {
      if (!selectedDetailId) {
        openSnack("Seleccione una línea de la CPO", "error");
        return;
      }
      const payload = {
        companyId,
        cpoDetailId: selectedDetailId,
        shippedQuantity: values.shippedQuantity,
        shippedDate: values.shippedDate.format("YYYY-MM-DD"),
      };
      await createCPOShipment(payload);
      openSnack("Envío guardado exitosamente", "success");
      setIsModalOpen(false);
      fetchData();
    } catch (e) {
      openSnack(handleError(e), "error");
    }
  };

  const handleDelete = async (shipment) => {
    if (!window.confirm(`¿Eliminar el envío No. ${shipment.shipmentNo}?`)) {
      return;
    }
    try {
      await deleteCPOShipment(shipment.id);
      openSnack("Envío eliminado exitosamente", "success");
      fetchData();
    } catch (e) {
      openSnack(handleError(e), "error");
    }
  };

  const fetchData = async () => {
    if (!selectedDetailId) {
      setShipments([]);
      return;
    }
    try {
      const res = await getCPOShipments({ cpoDetailId: selectedDetailId });
      setShipments(res.data);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    if (!selectedDetailId && details.length > 0) {
      setSelectedDetailId(details[0].id);
    }
  }, [details, selectedDetailId]);

  useEffect(() => {
    fetchData();
  }, [selectedDetailId]);

  const detailLabel = (d) => {
    const code = d.finishedGood?.code || d.finishedGoodId;
    const name = d.finishedGood?.name || "";
    return `${code}${name ? ` | ${name}` : ""} (qty ${d.quantity})`;
  };

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormControl fullWidth size="small">
            <InputLabel id="cpo-detail-select-label">Línea</InputLabel>
            <Select
              labelId="cpo-detail-select-label"
              label="Línea"
              value={selectedDetailId || ""}
              onChange={(e) => setSelectedDetailId(e.target.value)}
            >
              {details.map((d) => (
                <MenuItem key={d.id} value={d.id}>
                  {detailLabel(d)}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid
          item
          xs={12}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="h6">
            Envíos
            {selectedDetail
              ? ` — ${shippedTotal} / ${selectedDetail.quantity || 0}`
              : ""}
          </Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={() => setIsModalOpen(true)}
            disabled={!selectedDetailId}
          >
            Nuevo Envío
          </Button>
        </Grid>
        <Grid item xs={12}>
          <CPOShipmentList shipments={shipments} onDelete={handleDelete} />
        </Grid>
      </Grid>

      <LGModal
        open={isModalOpen}
        handleClose={() => setIsModalOpen(false)}
        header="Nuevo Envío"
      >
        <CPOShipmentForm onSubmit={handleSubmit} />
      </LGModal>
    </Box>
  );
};

export default CPOShipments;
